export const SET_AUTH = "SET_AUTH";
export const SET_PREMIUM_ACCOUNT = "SET_PREMIUM_ACCOUNT";
export const SET_AUTHENTICATING = "SET_AUTHENTICATING";

export const setAuth = payload => ({type: SET_AUTH, payload});
export const setPremiumAccount = payload => ({type: SET_PREMIUM_ACCOUNT, payload});
export const setAuthenticating = payload => ({type: SET_AUTHENTICATING, payload});
